import { render, staticRenderFns } from "./CustomerTransfer.vue?vue&type=template&id=02475d5c&"
import script from "./CustomerTransfer.vue?vue&type=script&lang=js&"
export * from "./CustomerTransfer.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports